interface IGetCompanyMatchLabelReturn {
  label: string;
  text: string;
}

type TGetCompanyMatchLabelPayload = Partial<{
  averageRating: number;
  hasBadges: boolean;
  hasWorkedWithDSO: boolean;
  hasWorkedWithOffice: boolean;
  isDSO: boolean;
  officeName: string;
}>;

export const getCompanyMatchLabel = ({
  averageRating,
  hasBadges,
  hasWorkedWithDSO,
  hasWorkedWithOffice,
  isDSO,
  officeName,
}: TGetCompanyMatchLabelPayload): IGetCompanyMatchLabelReturn | null => {
  if (!!averageRating && averageRating >= 4.8 && hasBadges) {
    if (isDSO && hasWorkedWithDSO) {
      return { label: 'Company Experience', text: `Has worked with ${officeName} before.` };
    }

    if (!isDSO && hasWorkedWithOffice) {
      return { label: 'Returning Professional', text: `Has worked with ${officeName} before.` };
    }
  }

  return null;
};
